import { createContext, useState, useContext, type PropsWithChildren, type Dispatch, type SetStateAction, useRef, type RefObject  } from "react";

export const AppContext = createContext<{
    mobileNavigationMenu: [boolean, Dispatch<SetStateAction<boolean>>],
    miniContactMenu: [boolean, Dispatch<SetStateAction<boolean>>],
    miniContactMenuCloseTimeoutId?: RefObject<number | null>,
    navigationBarAnchor: RefObject<HTMLElement | null> | undefined,
    homepageAnchors: Record<string, RefObject<HTMLElement | null>>,
}>({
    mobileNavigationMenu: [false, (value: SetStateAction<boolean>) => value],
    miniContactMenu: [false, (value: SetStateAction<boolean>) => value],
    miniContactMenuCloseTimeoutId: undefined,
    navigationBarAnchor: undefined,
    homepageAnchors: {},
});

export const AppProvider = ({ children }: PropsWithChildren<{}>) => {
    const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);
    const [contactMenuOpen, setContactMenuOpen] = useState(false);
    const closeTimeoutId = useRef<number | null>(null);

    return <AppContext.Provider value={{
        mobileNavigationMenu: [mobileNavigationOpen, setMobileNavigationOpen],
        miniContactMenu: [contactMenuOpen, setContactMenuOpen],
        miniContactMenuCloseTimeoutId: closeTimeoutId,
        navigationBarAnchor: useRef(null),
        homepageAnchors: {
            home: useRef(null),
            about: useRef(null),
            services: useRef(null),
            testimonials: useRef(null),
        }
    }}>
        {children}
    </AppContext.Provider>
};

export function useAppContext() {
    return useContext(AppContext);
}
